module.exports = "<!-- <p> aside-left-display-disabled works! </p> -->\n<div>\n\t<router-outlet></router-outlet>\n</div>"